<template>
    <section class="benefits-collapsible-section" :class="{ open: isOpen }">
        <button class="benefits-collapsible-header" type="button" :aria-expanded="isOpen ? 'true' : 'false'"
            @click="isOpen = !isOpen">
            <span>{{ title }}</span>

            <Icon :icon-class="isOpen ? 'ui-chevron-up' : 'ui-chevron-down'" size="6" color="#1f2a37" />
        </button>

        <div v-if="isOpen" class="benefits-collapsible-content">
            <slot></slot>
        </div>
    </section>
</template>

<script>
import Icon from "../../components/icon/icon";

export default {
    name: "BenefitsCollapsibleSection",
    components: {
        Icon,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        defaultOpen: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isOpen: this.defaultOpen,
        };
    },
};
</script>

<style lang="scss" scoped>
.benefits-collapsible-section {
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-bottom: 24px;
    width: 100%;
}

.benefits-collapsible-header {
    align-items: center;
    align-self: flex-start;
    appearance: none;
    background: transparent;
    border: 0;
    color: #1f2a37;
    cursor: pointer;
    display: flex;
    gap: 16px;
    justify-content: flex-start;
    padding: 0;
    text-align: left;
    max-width: 100%;

    span {
        font-family: "Sora", sans-serif;
        font-size: 24px;
        font-weight: 400;
        line-height: 1.3;
        min-width: 0;
        overflow-wrap: anywhere;
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        border-radius: 8px;
        box-shadow: 0 0 0 2px rgba(56, 66, 80, 0.18);
    }
}

.benefits-collapsible-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
}

@media (max-width: 767px) {
    .benefits-collapsible-section {
        gap: 16px;
        padding-bottom: 20px;
    }

    .benefits-collapsible-header {
        gap: 12px;

        span {
            font-size: 20px;
        }
    }

    .benefits-collapsible-content {
        gap: 16px;
    }
}
</style>
